import ThirdPartSoftware from "@/components/third-part-softwares/third-part-softwares";
import SettingsFormContainer, {
  SettingsFormHeader,
} from "@babackapp/react-hook-forms-components/form-page";
import useTranslation from "@babackapp/translations/use-translation";
import APIKeyCard from "./components/api-key/api-key";
import DomainsList from "./components/domains-settings/domains-list";
import ExportSettings from "./components/export-settings/export-settings";
import WebhooksList from "./components/webhooks/webhooks-list";
import ImportSettings from "./components/import-settings/import-settings";

export default function IntegrationsPage() {
  const t = useTranslation();

  return (
    <SettingsFormContainer>
      <SettingsFormHeader
        title={t("sidebar.integrations")}
        description={
          "Configure how Baback integrates with your other tools and services."
        }
      />
      <APIKeyCard />
      <DomainsList />
      <ExportSettings />
      <ImportSettings />
      <WebhooksList />
      <ThirdPartSoftware />
    </SettingsFormContainer>
  );
}
